import React from 'react';
import { Container } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Button from '@michelin/acid-components/build/components/Button/Button';
import { useTranslation } from '@michelin/central-provider';

interface LimitsMessagesProps {
  hasApprovalLimits?: boolean;
  hasContacts?: number;
  getLimitsError: boolean;
  isDealer: boolean;
  setGetLimitsError: (e: boolean) => void;
}

export default function LimitsMessages(props: LimitsMessagesProps) {
  const { t } = useTranslation();
  const { hasApprovalLimits, hasContacts, isDealer, getLimitsError, setGetLimitsError } = props;
  return (
    <Container
      style={{
        marginTop: 8,
        marginBottom: 16,
        marginLeft: 0,
        marginRight: 0,
      }}
    >
      {!getLimitsError && !hasApprovalLimits && !!hasContacts && (
        <Alert severity="warning" style={{ fontSize: 18 }}>
          {t(
            'This Order is over your approved spending limit. A notification will be sent to the proper contact(s) in order to approve it',
          )}
        </Alert>
      )}
      {!getLimitsError && !hasApprovalLimits && !hasContacts && isDealer && (
        <Alert severity="error" style={{ fontSize: 18 }}>
          {t(
            'A Fleet Administrator is not assigned to this account, and orders cannot be processed at this time. ' +
              'Please contact maestro.support@michelin.com.',
          )}
        </Alert>
      )}
      {!getLimitsError && !hasApprovalLimits && !hasContacts && !isDealer && (
        <Alert severity="error" style={{ fontSize: 18 }}>
          {t('There are no users configured to approve orders on this fleet. Please contact your administrator.')}
          <Button
            size="small"
            color="danger"
            onClick={() => {
              setGetLimitsError(false);
            }}
            style={{ marginLeft: 8 }}
          >
            {t('Retry')}
          </Button>
        </Alert>
      )}
      {getLimitsError && (
        <Alert severity="error" style={{ fontSize: 18 }}>
          {t(
            'Your approval limit information cannot be accessed. You may retry your request or contact your administrator.',
          )}
          <Button
            size="small"
            color="danger"
            onClick={() => {
              setGetLimitsError(false);
            }}
            style={{ marginLeft: 8 }}
          >
            {t('Retry')}
          </Button>
        </Alert>
      )}
    </Container>
  );
}
